<template>
    <td-dialog :lockScroll="false" :title="$t(title)" :visible.sync="dialogAddVisible" :before-close="cancel" width="380px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formAddLogSetting" ref="formAddLogSetting" label-width="100px" :rules="rules">
            <el-form-item :label="$t('logCommon.RES_TYPE')" prop="resTypeId">
                <td-select v-model="formAddLogSetting.resTypeId" :disabled="disabled" :options="resOptions" keys="value" text="label"  :multiple="multiple" :collapse-tags="collapse" @change="changeResType"></td-select>
            </el-form-item>
            <el-form-item :label="$t('logCommon.AUTH_TYPE')" prop="authTypeId">
                <td-select v-model="formAddLogSetting.authTypeId" :disabled="disabled" :options="authOptions" keys="value" text="label" :multiple="multiple" :collapse-tags="collapse" @change="changeAuthType"></td-select>
            </el-form-item>
            <el-form-item :label="$t('logCommon.TEMPLATE')" prop="logTemplateId" style="margin-bottom:10px;">
                <td-select v-model="formAddLogSetting.logTemplateId" :options="templateOptions" keys="value" text="label"></td-select>
            </el-form-item>
            <span v-if="tipVisiable" style="color: red; margin-left: 20px;">{{$t('logMessage.OVERRIDE_WHEN_EXISTS')}}</span>
            <el-form-item :label="$t('logCommon.SAVE_FLG')" prop="saveFlg">
                <td-switch v-model="formAddLogSetting.saveFlg" activeText="" inactiveText="" @change="changeSwitch"></td-switch>
            </el-form-item>

        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formAddLogSetting')">{{ $t('logCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('logCommon.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: ['title', 'dialogAddVisible', 'sSysFlg', 'isAddData', 'editItem'],
    components: {},
    created() {
        // 获取操作权限类型列表
        this.queryOperationType();
        // 获取资源类型列表
        this.getAllResType();
        // 获取描述模板列表
        this.queryTemplate();
        // 编辑
        if (!this.isAddData) {
            this.disabled = true;
            this.tipVisiable = false;
            this.formAddLogSetting.resTypeId = [this.editItem.resTypeId];
            this.formAddLogSetting.authTypeId = [this.editItem.authTypeId];
            this.formAddLogSetting.logTemplateId = this.editItem.logTemplateId;
            this.formAddLogSetting.saveFlg = this.editItem.saveFlg == 1 ? true : false;
            this.saveFlg = this.editItem.saveFlg;
        }
    },
    mounted() {
    },
    // 定义变量
    data() {
        return {
            disabled: false,
            tipVisiable: true,
            saveLoading: false,
            sType: 'LOG',
            formAddLogSetting: {
               resTypeId: null,
               authTypeId: null,
               logTemplateId: null
            },
            resOptions: [],
            authOptions: [],
            templateOptions: [],
            resOptionsValues: [],
            authOptionsValues: [],
            multiple: true,
            collapse: true,
            saveFlg: 0,
            rules: {
                resTypeId: [{ required: true, trigger: 'blur', message: this.$t('logError.PLEASE_SELECT_RES') }],
                authTypeId: [{ required: true, trigger: 'blur', message: this.$t('logError.PLEASE_SELECT_AUTH') }],
                logTemplateId: [{ required: true, trigger: 'blur', message: this.$t('logError.PLEASE_SELECT_TEMPLATE') }],
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 获取资源类型列表
        getAllResType() {
            let allResTypeParam = { 
                sSysFlg: this.sSysFlg 
            };
            api.getAllResType(JSON.stringify(allResTypeParam), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/logSettingManager/getAllResType', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/logSettingManager/getAllResType', response.data.statusMessage);
                    return;
                }
                let typeList = response.data.content;
                if (typeList && typeList.length != 0) {
                    this.resOptions = [
                        {
                            value: 'all',
                            label: this.$t('common.ALL')
                        }
                    ];
                    for (let i = 0; i < typeList.length; i++) {
                        let temValue = typeList[i];
                        let item = {
                            value: temValue.sId,
                            label: temValue.sName
                        };
                        this.resOptions.push(item);
                        this.resOptionsValues.push(item.value);
                    }
                }
            });
        },
        // 获取操作权限类型列表
        queryOperationType() {
            let operationTypeParam = {
                sSysFlg: this.sSysFlg 
            };
            api.queryOperationType(JSON.stringify(operationTypeParam), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/logSettingManager/queryOperationType', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/logSettingManager/queryOperationType', response.data.statusMessage);
                    return;
                }
                let typeList = response.data.content;
                if (typeList && typeList.length != 0) {
                    this.authOptions = [
                        {
                            value: 'all',
                            label: this.$t('common.ALL')
                        }
                    ];
                    for (let i = 0; i < typeList.length; i++) {
                        let temValue = typeList[i];
                        let item = {
                            value: temValue.sId,
                            label: temValue.sCaption
                        };
                        this.authOptions.push(item);
                        this.authOptionsValues.push(item.value);
                    }
                }
            });
        },
        // 获取描述模板列表
        queryTemplate() {
            let templateParam = {
                sType: this.sType 
            };
            api.queryTemplate(templateParam, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/logSettingManager/queryTemplate', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/logSettingManager/queryTemplate', response.data.statusMessage);
                    return;
                }
                let typeList = response.data.content;
                if (typeList && typeList.length != 0) {
                    for (let i = 0; i < typeList.length; i++) {
                        let temValue = typeList[i];
                        let item = {
                            value: temValue.sSign,
                            label: temValue.sName
                        };
                        this.templateOptions.push(item);
                    }
                }
            });
        },
        // 资源类型变化事件监听
        changeResType: function(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.formAddLogSetting.resTypeId = data;
                    } else {
                        this.formAddLogSetting.resTypeId = ['all'];
                    }
                }
            });
        },
        // 操作类型变化事件监听
        changeAuthType: function(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.formAddLogSetting.authTypeId = data;
                    } else {
                        this.formAddLogSetting.authTypeId = ['all'];
                    }
                }
            });
        },
        // 设置假期余额开关值变化时调用的方法
        changeSwitch(value) {
            this.saveFlg = value;
        },
        // 取消
        cancel() {
            this.$emit('dialogClose');
        },
        // 保存
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    this.tableLoading = true;
                    if (this.isAddData) {
                        let param = {
                            resTypeIdList: this.formAddLogSetting.resTypeId,
                            authTypeIdList: this.formAddLogSetting.authTypeId,
                            saveFlg: this.saveFlg,
                            logTemplateId: this.formAddLogSetting.logTemplateId
                        };
                        if (this.formAddLogSetting.resTypeId && this.formAddLogSetting.resTypeId.indexOf('all') > -1) {
                            param.resTypeIdList = this.resOptionsValues;
                        }
                        if (this.formAddLogSetting.authTypeId && this.formAddLogSetting.authTypeId.indexOf('all') > -1) {
                            param.authTypeIdList = this.authOptionsValues;
                        }
                        api.batchAddLogSetting(JSON.stringify(param), response => {
                            this.saveLoading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/logSettingManager/batchAddLogSetting', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            this.$emit('dialogSaveClose');
                        });
                    } else {
                        let param = {
                            sIdList: this.editItem.id,
                            saveFlg: this.saveFlg,
                            logTemplateId: this.formAddLogSetting.logTemplateId
                        };
                        api.batchUpdateLogSetting(JSON.stringify(param), response => {
                            this.saveLoading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/logSettingManager/batchUpdateLogSetting', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            this.$emit('dialogSaveClose');
                        });
                    }
                }
            });
        }
    }
};
</script>